<template>
    <div>
        <HeadNav selectedLanguage="en" page="download" />
        <div class="features-section">
<h1>Top Features of GB WhatsApp in 2026</h1>
            <div class="discover-features">
                Discover what makes <a href="https://gbmodshub.com/" class="jump-url">GBWhatsApp</a> the ultimate WhatsApp mod. With enhanced privacy, full customization,
                and advanced messaging tools, GB WhatsApp gives you more control than the official app ever could.
            </div>
            <div class="features-list">
                <a v-for="(item, index) in featuresList" :key="index" class="feature-item" :href="item.link">
                    <div class="feature-title">
                        <img :src="item.img" alt="features-icon">
                    </div>
                    <div>
                        <strong>{{ item.title }}</strong>
                    </div>
                </a>
            </div>
            <h2 class="intro-title">Key Features of GB WhatsApp</h2>
            <div class="quick-overview">
                <strong>🎨 Advanced Customization Options</strong> <br>
                Personalize your entire WhatsApp experience — change themes, fonts, chat bubbles, tick styles, and even app icons. Make GB WhatsApp truly yours. <br><br>
                <strong>🔐 Enhanced Privacy Settings</strong> <br>
                Control your visibility like never before. Hide your online status, blue ticks, typing indicators, and more. Choose who sees what — on your terms. <br><br>
                <strong>📁 Larger File Sharing</strong> <br>
                Send high-resolution photos, long videos (up to 100MB+), documents, and more — without the compression limits of the official WhatsApp.<br><br>
                <strong>🖼️ Multiple Media Selection</strong> <br>
                Select and send up to 100 images or media files at once, streamlining bulk sharing for events, groups, or media-heavy chats. <br><br>
                <strong>🔒 Built-in App Lock</strong> <br>
                Secure your chats with an in-app lock using PIN, pattern, or fingerprint — no need for third-party lock apps. <br><br>
                <strong>⏳ Disappearing Messages</strong>    <br>
                Enable disappearing messages for private conversations — automatically delete chats after a set time for added privacy. <br><br>
                <strong>⬇️ Status Download Feature</strong>  <br>
                Download WhatsApp statuses (photos & videos) from your contacts directly with one tap — no external apps required.
            </div>
        </div>
    </div>
</template>
<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
    name: 'Features',
    components: {
        HeadNav},
    data() {
        return {
            apk: null,
            featuresList: [
                {
                    title: "Advanced Customization Options",
                    img: require('@/assets/icon/icon1.webp'),
                    link:'https://gbmodshub.com/advanced-customization-options-in-gb-whatsapp/'
                },
                {
                    title: "Enhanced Privacy Settings",
                    img: require('@/assets/icon/icon2.webp'),
                    link:'https://gbmodshub.com/enhanced-privacy-settings-in-gb-whatsapp/'
                },
                {
                    title: "Dual WhatsApp Accounts",
                    img: require('@/assets/icon/icon3.webp'),
                    link: 'https://gbmodshub.com/dual-whatsapp-accounts-gbwhatsapp/',
                },
                {
                    title: "Larger File Sharing",
                    img: require('@/assets/icon/icon4.webp'),
                    link: 'https://gbmodshub.com/gb-whatsapp-larger-file-sharing/',
                },
                {
                    title: "Multiple Media Selection",
                    img: require('@/assets/icon/icon5.webp'),
                    link: 'https://gbmodshub.com/multiple-media-selection-gbwhatsapp/',
                },
                {
                    title: "Built-in App Lock",
                    img: require('@/assets/icon/icon6.webp'),
                    link: 'https://gbmodshub.com/built-in-app-lock-gbwhatsapp/',
                },
                {
                    title: "Disappearing Messages",
                    img: require('@/assets/icon/icon7.webp'),
                    link: 'https://gbmodshub.com/disappearing-messages-gbwhatsapp/',
                },
                {
                    title: "Status Download Feature",
                    img: require('@/assets/icon/icon8.webp'),
                    link: 'https://gbmodshub.com/status-download-feature-gbwhatsapp/',
                },
            ],
        }
    },
    mounted() {
        this.getOfficalApk();
    },
    methods: {
        getOfficalApk(type = 1, domain = null, appname = null) {
            this.$server
                .getOfficalApk({
                    domain: domain || 'gbwhatsapp.chat',
                    appName: appname || 'GB_gbwhatsapp.chat',
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        if (type == 1) {
                            this.apk = res.data.apk;
                        }

                    } else {
                        this.apk = process.env.VUE_APP_GBLINK;
                    }
                });
        },
        goJump(url) {
            window.location.href = url;
        },
        gotodownload() {
            console.log(this.apk);
            // this.showapk = true
            if (this.apk) {
                this.$global.download(this.apk);
            }

        },
    }
}
</script>